export interface OnboardingCelebrationState {
  onboardingCelebration: true;
}

export function createOnboardingCelebrationState(): OnboardingCelebrationState {
  return { onboardingCelebration: true };
}

export function shouldCelebrateOnboarding(state: unknown): boolean {
  return (
    typeof state === "object" &&
    state !== null &&
    "onboardingCelebration" in state &&
    state.onboardingCelebration === true
  );
}
